import { DependencyList, useCallback } from 'react';
import memoize from 'lodash/memoize';
import { FnWithAnyProps } from '../interfaces/FnWithAnyProps';
import { CustomAny } from '../types/generics';

export const useMemoizedCallback = <T extends FnWithAnyProps<CustomAny>>(callback: T, deps: DependencyList = []): T =>
  useCallback(memoize(callback), deps);
